import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { AnalyticsConfig, AnalyticsRequestModel } from '../config/analytics.config';
import { MONTHS, YEARS } from '../../../../shared/consts/date.const';
import { BillingService, CalcBillingService } from '../../../../venues/venue-billing/venue-billing.service';
import { MemberAnalyticsService } from '../service/member-analytics.service';

@Component({
  selector: 'app-analytics-table',
  templateUrl: './analytics-table.component.html',
  styleUrls: [
    '../../application-management-table.component.less',
    '../../../../venues/venue-billing/venue-billing.component.less',
    './analytics-table.component.less',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BillingService, CalcBillingService, MemberAnalyticsService],
})
export class AnalyticsTableComponent implements OnInit {
  @Input() applicants;
  @Input() activeTab: string;

  @Output() showApplicantChange = new EventEmitter();
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  isMonthsView = true;
  analyticsGridConfiguration: AnalyticsConfig;
  analyticsGridRequest: AnalyticsRequestModel;

  months = MONTHS;
  years = YEARS;
  selectedYear: any;
  selectedMonth: any;
  initYear: any;

  constructor(
    private memberAnalyticsService: MemberAnalyticsService,
  ) {
  }

  ngOnInit() {
    this.analyticsGridConfiguration = new AnalyticsConfig();
    this.analyticsGridConfiguration.service = this.memberAnalyticsService;
    this.analyticsGridRequest = new AnalyticsRequestModel();

    this.dateInit();
  }

  toggleView(): void {
    this.isMonthsView = !this.isMonthsView;

    if (this.isMonthsView) {
      this.refreshGrid();
    } else {
      this.allTimeAnalytics();
    }
  }

  dateInit() {
    const today = new Date();
    this.selectedYear = this.years.indexOf(this.years.find(x => x.year === today.getFullYear()));
    this.initYear = today.getFullYear();
    this.selectedMonth = today.getMonth() + 1;

    if (this.selectedMonth === 0) {
      this.selectedMonth = 12;
      this.selectedYear--;
      this.initYear--;
    }

    this.analyticsGridRequest.month = this.selectedMonth;
    this.analyticsGridRequest.year = this.initYear;
  }

  search(value) {
    this.analyticsGridConfiguration.customSearch[0].value = value;
    this.analyticsGridConfiguration.customSearch[1].value = value;
    this.analyticsGridConfiguration.dataGrid.instance.getDataSource().reload();
  }


  // Date manipulation

  previousMonth() {
    if (this.selectedMonth === 1) {
      this.selectedMonth = 12;
      this.selectedYear--;
    } else {
      this.selectedMonth--;
    }

    this.refreshGrid();
  }

  nextMonth() {
    if (this.selectedMonth === 12) {
      this.selectedMonth = 1;
      this.selectedYear++;
    } else {
      this.selectedMonth++;
    }

    this.refreshGrid();
  }

  previousYear() {
    if (this.selectedYear === 0) {
      this.selectedYear = this.years.length - 1;
    } else {
      this.selectedYear--;
    }

    this.refreshGrid();
  }

  nextYear() {
    if (this.years.length === this.selectedYear + 1) {
      this.selectedYear = 0;
    } else {
      this.selectedYear++;
    }

    this.refreshGrid();
  }

  private refreshGrid() {
    this.analyticsGridRequest.month = this.selectedMonth;
    this.analyticsGridRequest.year = this.years[this.selectedYear].year;

    this.analyticsGridConfiguration.refreshGrid();
  }

  private allTimeAnalytics(): void {
    this.analyticsGridRequest.month = null;
    this.analyticsGridConfiguration.refreshGrid();
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/analitycs/analytics-table/analytics-table.component.ts